module.exports = __webpack_public_path__ + "static/media/2-3.2385064f.svg";